var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/login"}},[_vm._v(_vm._s(_vm.$t('recovery.password.footer')))])}
var staticRenderFns = []

export { render, staticRenderFns }